'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _Webform = require('../Webform');

var _Webform2 = _interopRequireDefault(_Webform);

var _Parser = require('../Parser');

var _BaseButton = require('../BaseButton');

var _BaseButton2 = _interopRequireDefault(_BaseButton);

var _Form = require('../Observables/Form');

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubmitButton = function SubmitButton(_ref) {
  var field = _ref.field,
      formStore = _ref.formStore,
      status = _ref.status,
      show = _ref.show,
      loadingTimeout = _ref.loadingTimeout,
      loadingComponent = _ref.loadingComponent;

  if (field['#submit__hide'] === true || show === false && formStore.isMultipage()) {
    return null;
  }

  var disabled = status === _Webform2.default.formStates.PENDING;

  var label = (0, _Parser.template)(formStore, field['#submit__label']);

  if (!label || label === '') {
    return null;
  }

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_BaseButton2.default, {
      disabled: disabled,
      label: label,
      formSubmitAttributes: field['#submit__attributes'],
      type: 'submit'
    }),
    loadingTimeout && loadingComponent
  );
};

SubmitButton.meta = {
  labelVisibility: 'invisible'
};

SubmitButton.propTypes = {
  field: _propTypes2.default.shape().isRequired,
  status: _propTypes2.default.string.isRequired,
  formStore: _propTypes2.default.instanceOf(_Form2.default).isRequired,
  show: _propTypes2.default.bool,
  loadingTimeout: _propTypes2.default.bool.isRequired,
  loadingComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node])
};

SubmitButton.defaultProps = {
  type: 'button',
  show: false,
  loadingComponent: undefined
};

var DecoratedSubmitButton = (0, _mobxReact.inject)('formStore')((0, _mobxReact.observer)(SubmitButton));

DecoratedSubmitButton.meta = SubmitButton.meta;

exports.default = DecoratedSubmitButton;